import restUtils from "core/utils/rest";

export function fetchInvestorTrs(personId: string) {
  return restUtils.call(
    "PortalApi",
    `hubwise-api/aml/kyc/investor/${personId}/trs`,
    "GET"
  ).then((response) => {
    return response;
  });
}
